import { isBrowser } from "../../../Helpers/BrowserHelpers";

export function getFromLocalStorage<T>(key: string, defaultValue: T): T {
    if (!isBrowser) {
        return defaultValue;
    }
    try {
        const item = window.localStorage.getItem(`Candy:${key}`);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return item ? JSON.parse(item) : defaultValue;
    } catch {
        return defaultValue;
    }
}

export function setToLocalStorage<T>(key: string, value: T): void {
    if (!isBrowser) {
        return;
    }
    window.localStorage.setItem(`Candy:${key}`, JSON.stringify(value));
}
